;(function($, window, document, undefined) {
	var $win = $(window);
	var $doc = $(document);
	var product = window.product;
	var $product;

	$doc.ready(function() {
		$product = $('#product');

		// Label focus move
		$('.field, .textarea').on('keydown keyup', function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};

		}).each(function() {
			var $field = $(this),
				$parent = $field.parent(),
				$label = $field.prev('label');

			if ($label.length) {
				$parent.toggleClass('form-show-label', Boolean($field.val().length) );
			};

		});

		// Mobile Menu

		$('.btn-menu').on('click', function (event) {
			$(this).toggleClass('active').closest('body').toggleClass('header-visible');
			event.preventDefault();
		});

		
			// Product Popup
			$('.link-popup').magnificPopup({
				type: "image",
				gallery: {
					enabled: true
				}
			});

		

		// Product Slider
		


		$('.addresses .cancel').on('click', function(event) {
			var $section = $(this).closest('.accordion-section');

			$section.find('.accordion-body').slideUp();

			event.preventDefault();
		});

		$('.btn-new-adress, .form-add-address .cancel').on('click', function(event) {

			$('.form-add-address').slideToggle();

			event.preventDefault();
		});

		if ($product.length) {
			var $product_stock =  $('.product__stock');
			var $AddToCart = $('#AddToCart');

			new Shopify.OptionSelectors('product-select', {
				product: window.product,
				onVariantSelected: function(variant, selector) {

					var price = Shopify.formatMoney(variant.price, Shopify.money_format);
					var compare_at_price = Shopify.formatMoney(variant.compare_at_price, Shopify.money_format);

					if (variant.compare_at_price > variant.price) {
						price += ' - <span class="compare-price">' + compare_at_price + '</span>';
					};

					if (variant.available) {
						$product_stock.text('In Stock');
						$AddToCart.attr('disabled', false);
					} else {
						$AddToCart.attr('disabled', true);
						$product_stock.text('Out Of Stock');
					};

					$('.product__price', $product).html(price).toggleClass('out-of-stock', !variant.available);

					if (variant.featured_image) {
						var imageSrc = variant.featured_image.src,
							image = imageSrc.split('/');
							image =  image[image.length - 1];

						$('[data-image*="'+ image +'"]').trigger('change.image');
					}

				},
				enableHistoryState: true
			});

			if (product && product.variants.length == 1 && product.variants[0].title.indexOf('Default') == 0 ) {
				$('.selector-wrapper').hide();
			};
		};
	});

	Shopify.CustomerAddress = {
		toggleForm: function(address_id) {
			var $form = $('#address_form_' + address_id),
				$section = $form.closest('.accordion-section');

			$section.find('.accordion-body').slideDown();

			$section.siblings().find('.accordion-body').stop(true, true).slideUp();

			return false;
		},

		destroy: function(id, confirm_msg) {
			if (confirm(confirm_msg || "Are you sure you wish to delete this address?")) {
				Shopify.postLink('/account/addresses/'+id, {'parameters': {'_method': 'delete'}});
			}
		}
	}
})(jQuery, window, document);
